export default __webpack_public_path__ + "static/media/app-logo-w.e3382870.svg";